import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ElementOrNewElement } from "@/react/types/Element";
import { type BlockMeta, getElementIds } from "../shared/blockUtils";

interface Option {
  id: string;
  value: string;
}

export const blockToElement = (block: BaseBlock): ElementOrNewElement => {
  const meta = block.meta as BlockMeta | undefined;
  const { elementId, elementableId } = getElementIds(block);

  const optionsValue = block.props.options?.value as Option[] | undefined;
  const options = optionsValue?.map(option => option.value) || [];

  return {
    id: elementId,
    type: "field",
    position: meta?.position ?? 0,
    elementable_id: elementableId,
    parent_element_id: meta?.parentElementId ?? null,
    attributes: {
      field_type: "dropdown",
      label: (block.props.label?.value as string) || "",
      placeholder: null,
      required: (block.props.required?.value as boolean) || false,
      hidden: false,
      options,
    },
  } as ElementOrNewElement;
};
